/**
 * CL-SCHEDULE-001B — Central schedule portal capabilities (pure).
 */

import { CLIENT_PORTAL_MODULE_PERMISSION_KEYS } from "./clientPortalModulePermissionKeys";

function safeStr(value) {
  return String(value ?? "").trim();
}

function isClientRole(role = "") {
  return safeStr(role).toLowerCase() === "client";
}

function readExplicitBoolean(source = {}, key = "") {
  return source?.[key] === true;
}

function assignmentPermissions(assignment = null) {
  return assignment?.permissions && typeof assignment.permissions === "object"
    ? assignment.permissions
    : {};
}

/**
 * Effective schedule capabilities for portal routing and UI.
 */
export function resolveSchedulePortalCapabilities({
  isAdmin = false,
  isClientPersona = false,
  permissions = {},
  assignment = null,
} = {}) {
  const perms = {
    ...assignmentPermissions(assignment),
    ...permissions,
  };
  const role = safeStr(assignment?.role || (isClientPersona ? "client" : "collaborator"));

  if (isAdmin) {
    return {
      canViewSchedule: true,
      canEditSchedule: true,
      canReadScheduleChangeEvents: true,
      clientReadOnly: false,
      useClientVisibleQuery: false,
    };
  }

  const explicitView = readExplicitBoolean(perms, CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule);
  const explicitEdit = readExplicitBoolean(perms, "canEditSchedule");
  const clientReadOnly = isClientPersona || isClientRole(role);

  const canEditSchedule = !clientReadOnly && explicitEdit === true;
  const canViewSchedule = explicitView === true || canEditSchedule === true;

  return {
    canViewSchedule,
    canEditSchedule,
    canReadScheduleChangeEvents: canEditSchedule === true,
    clientReadOnly,
    useClientVisibleQuery: clientReadOnly && canViewSchedule === true,
  };
}

export function scheduleTabAllowedForContributor(scheduleCaps = {}) {
  return scheduleCaps.canViewSchedule === true || scheduleCaps.canEditSchedule === true;
}
